import { Navigate, Outlet, useLocation, useMatches } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { AppLoading } from "@/components/feedback/AppLoading";
import { TenantSelectionGate } from "@/components/layout/TenantSelectionGate";
import ForbiddenPage from "@/pages/errors/ForbiddenPage";
import { canAccessRouteHandle, type RouteHandle } from "@/config/routes";

export function ProtectedShell() {
  const {
    status,
    user,
    currentTenantId,
    hasPermission,
    hasAnyPermission,
    hasModuleLevel,
    isSuperadmin,
  } = useAuth();
  const location = useLocation();
  const matches = useMatches();
  const handle =
    (matches[matches.length - 1]?.handle as RouteHandle | undefined) ?? {};

  if (status === "loading") return <AppLoading />;

  if (status === "unauthenticated") {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }

  if (user?.mustChangePassword) {
    return <Navigate to="/force-change-password" replace />;
  }

  if (!currentTenantId) {
    return <TenantSelectionGate />;
  }

  if (
    !canAccessRouteHandle(handle, {
      hasPermission,
      hasAnyPermission,
      hasModuleLevel,
      isSuperadmin,
    })
  ) {
    return <ForbiddenPage />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
